import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { sleep } from "@/utils";

export const Route = createFileRoute("/app/$role")({
  beforeLoad: async ({ params, context, location }) => {
    const { auth } = context;

    if (auth?.user?.role !== params.role) {
      auth?.logout();
      await sleep(100);
      throw redirect({ to: "/auth/login" });
    }

    // Check verification and onboarding status
    if (!location.pathname.includes("/setup")) {
      if (!auth.user.emailVerified) {
        throw redirect({
          to: "/auth/email-confirmation",
          search: { token: undefined },
        });
      } else if (!auth.user.phoneVerified) {
        throw redirect({ to: "/auth/verification" });
      } else if (!auth.user.onboardingCompleted) {
        throw redirect({
          to: "/app/$role/setup",
          params: { role: auth.user.role },
        });
      }
    }

    return { role: auth.user.role };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
